// Style constants for consistent design system

// Button styles
export const BUTTON_STYLES = {
  // Primary button (main CTA)
  primary: "px-8 py-4 bg-primary-600 dark:bg-primary-400 hover:bg-primary-700 text-white font-semibold rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 text-lg",

  // Secondary button (outline style)
  secondary: "px-8 py-4 border-2 border-accent-300 dark:border-accent-600 shadow-sm hover:shadow-md text-accent-800 dark:text-accent-200 font-semibold rounded-xl hover:bg-surface-100 dark:hover:bg-accent-800 transition-all duration-300 text-lg",

  // Small button variant
  primarySmall: "px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300",

  // Full width button (for forms)
  primaryFull: "w-full px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-lg",
};

// Container styles
export const CONTAINER_STYLES = {
  // Standard section container
  section: "py-20 px-4",

  // Standard content width
  content: "max-w-4xl mx-auto",

  // Wide content width (for case studies)
  contentWide: "max-w-5xl mx-auto",

  // Full width container
  full: "container mx-auto px-4 py-20",
};

// Typography styles
export const TYPOGRAPHY_STYLES = {
  // Section headings
  smallSectionTitle: "text-2xl md:text-3xl font-bold text-accent-900 dark:text-surface-50 mb-6 font-display text-center",

  // Section headings
  sectionTitle: "text-4xl md:text-5xl font-bold text-accent-900 dark:text-surface-50 mb-6 font-display text-center",

  // Section subtitles
  sectionSubtitle: "text-xl text-accent-600 dark:text-accent-400 text-center",

  // Card titles
  cardTitle: "text-2xl font-bold text-accent-900 dark:text-surface-50 mb-2",

  // Body text
  bodyText: "text-accent-700 dark:text-accent-300 leading-relaxed",
};

// Card styles
export const CARD_STYLES = {
  // Standard card
  base: "bg-white dark:bg-accent-800 rounded-xl shadow-lg border border-surface-200 dark:border-accent-700",

  // Interactive card with hover
  interactive: "bg-white dark:bg-accent-800 rounded-xl shadow-lg border border-surface-200 dark:border-accent-700 hover:shadow-xl transition-all duration-300",

  // Card with subtle background
  subtle: "bg-surface-100 dark:bg-accent-800 rounded-xl border border-surface-200 dark:border-accent-700",
};

// Common spacing
export const SPACING = {
  section: "py-20",
  sectionSmall: "py-16",
  cardPadding: "p-6",
  cardPaddingLarge: "p-8",
  marginBottom: "mb-6",
  marginBottomLarge: "mb-8",
};